import { createApp } from 'vue'
import './style.css'
import './styles/vant.less'
import App from './App.vue'

import { VantPlugin } from './plugins/vant'
import router from './router'
import pinia from './stores'
import i18n from './i18n'

const app = createApp(App)
app.use(i18n)
app.use(VantPlugin)
app.use(router)
app.use(pinia)
app.mount('#app')
